import { agentManager } from "@/manager";
import type { AgentResolveResponse } from "@/services/agent-resolve";

/**
 * 读取服务端 SSR 注入的智能体解析数据。
 * 数据由 Node 服务端（app.js）通过 <script type="application/json" id="__AGENT_RESOLVE_DATA__"> 数据岛注入。
 * dev 模式（vite dev）下数据岛内容是字面 EJS 文本，JSON.parse 会抛错，try/catch 兜底返回 null。
 */
export function readSSRAgentResolveData(): AgentResolveResponse | null {
  if (typeof document === "undefined") return null;
  try {
    const el = document.getElementById("__AGENT_RESOLVE_DATA__");
    if (!el?.textContent) return null;
    return JSON.parse(el.textContent) as AgentResolveResponse | null;
  } catch {
    return null;
  }
}

/**
 * 将 SSR 注入的智能体解析结果提前写入 agentManager。
 * 返回值用于上层决定是否打印日志等。
 */
export function seedResolvedAgentFromSSR(): AgentResolveResponse | null {
  const ssrAgentResolveData = readSSRAgentResolveData();
  if (!ssrAgentResolveData) return null;

  agentManager.seedResolvedAgent({
    id: ssrAgentResolveData.id,
    name: ssrAgentResolveData.name,
    avatar: ssrAgentResolveData.avatar,
    status: ssrAgentResolveData.status,
    agentExpiresAt: ssrAgentResolveData.agent_expires_at,
  });

  return ssrAgentResolveData;
}
